import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  List,
  ListItem,
  Typography,
} from "@mui/material";

const NumberBadge = ({ n }) => (
  <Box
    component="span"
    aria-hidden
    sx={{
      flexShrink: 0,
      width: { xs: 26, md: 28 },
      height: { xs: 26, md: 28 },
      borderRadius: "50%",
      bgcolor: "primary.main",
      color: "primary.contrastText",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: { xs: 12, md: 13 },
      fontWeight: 700,
      mt: "2px",
    }}
  >
    {n}
  </Box>
);

export const RegulationsSection = ({ title, icon, items = [], twoColumnsOnLg = false }) => (
  <Card
    variant="outlined"
    component="section"
    aria-label={title}
    sx={{ height: "100%", borderRadius: 3 }}
  >
    <CardHeader
      avatar={icon}
      title={
        <Typography
          variant="h6"
          component="h2"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "1.05rem", md: "1.15rem", lg: "1.25rem" },
            textTransform: "uppercase",
            letterSpacing: 0.4,
          }}
        >
          {title}
        </Typography>
      }
      sx={{ bgcolor: "action.hover", py: { xs: 1.5, md: 2 }, px: { xs: 2, md: 3 } }}
    />
    <Divider />
    <CardContent sx={{ px: { xs: 2, md: 3 }, py: { xs: 1, md: 2 } }}>
      <List
        disablePadding
        sx={{
          // En lg las secciones largas se parten en 2 columnas
          columnCount: { xs: 1, lg: twoColumnsOnLg ? 2 : 1 },
          columnGap: 4,
        }}
      >
        {items.map((text, i) => (
          <ListItem
            key={i}
            disableGutters
            sx={{
              alignItems: "flex-start",
              gap: 1.5,
              py: { xs: 1, md: 1.25 },
              breakInside: "avoid", // evita cortar un ítem entre columnas
            }}
          >
            <NumberBadge n={i + 1} />
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: "0.875rem", md: "0.9375rem" },
                lineHeight: 1.6,
              }}
            >
              {text}
            </Typography>
          </ListItem>
        ))}
      </List>
    </CardContent>
  </Card>
);

const Reglamento = ({ title, subtitle, sections = [] }) => (
  <Container
    maxWidth="lg"
    sx={{ py: { xs: 10, sm: 10, md: 10 }, px: { xs: 2, sm: 3 } }}
  >
    <Box sx={{ mb: { xs: 2, md: 4 }, textAlign: { xs: "left", md: "center" } }}>
      <Typography
        variant="h4"
        component="h1"
        sx={{
          textAlign:"center",
          fontWeight: 800,
          fontSize: { xs: "18px", sm: "20px", md: "22px", lg: "25px" },
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="subtitle1" color="text.secondary" sx={{ mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
    </Box>

    <Box
      sx={{
        display: "grid",
        gap: { xs: 2, md: 3 },
        // gridTemplateColumns: {
        //   xs: "1fr",
        //   sm: "1fr",
        //   md: "repeat(2, 1fr)",
        //   lg: "repeat(2, 1fr)",
        // },
        alignItems: "start",
        overflow: "scroll",
        maxHeight: "600px",
      }}
    >
      {sections.map((section) => (
        <Box
          key={section.id ?? section.title}
          sx={{
            // Una sección con muchos ítems ocupa todo el ancho en md/lg
            gridColumn: {
              md: section.fullWidth ? "1 / -1" : "auto",
            },
          }}
        >
          <RegulationsSection
            title={section.title}
            icon={section.icon}
            items={section.items}
            twoColumnsOnLg={section.fullWidth}
          />
        </Box>
      ))}
    </Box>
  </Container>
);

export default Reglamento;
